"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pass = void 0;
var Buffer = require('buffer/').Buffer;
var _1 = require("./");
var modena_1 = require("@axelity/modena");
var Pass = /** @class */ (function () {
    function Pass(_a) {
        var id = _a.id, passWallet = _a.passWallet, account = _a.account, context = _a.context, serial = _a.serial, issuer = _a.issuer, subject = _a.subject, validity = _a.validity, boxedSecret = _a.boxedSecret;
        this.id = id;
        this.passWallet = passWallet;
        this.account = account;
        this.context = context;
        this.serial = serial;
        this.issuer = issuer;
        this.subject = subject;
        this.validity = validity;
        this.boxedSecret = boxedSecret;
        if (!this.passWallet ||
            this.passWallet.length < 42 ||
            this.passWallet.length > 46) {
            throw new _1.ValidationError("A request to create a pass was generated. The request is rejected because the wallet identifier must be an existing, unique identifier of 42-46 characters.");
        }
        if (!this.account || this.account.length !== 27) {
            throw new _1.ValidationError("A request to create a pass was generated. The request is rejected because the account identifier must be an existing, unique identifier of 27 characters.");
        }
        if (!this.serial || this.serial.length !== 27) {
            throw new _1.ValidationError("A request to create a pass was generated. The request is rejected because the serial must be an unique identifier of 27 characters.");
        }
        if (!this.issuer ||
            this.issuer.id.length < 44 ||
            this.issuer.id.length > 88) {
            throw new _1.ValidationError("A request to create a pass was generated. The request is rejected because the issuer identifier must be an existing, unique identifier of 42-46 characters.");
        }
        if (!this.subject ||
            this.subject.id.length < 44 ||
            this.subject.id.length > 88) {
            throw new _1.ValidationError("A request to create a pass was generated. The request is rejected because the subject identifier must be an existing, unique identifier of 42-46 characters.");
        }
        if (!this.validity ||
            this.validity.notBefore < new Date('2020-01-01T00:00:00.000Z').getTime()) {
            throw new _1.ValidationError("A request to create a pass was generated. The request is rejected because the validity not-before date must be after 2020-01-01.");
        }
        if (!this.validity ||
            this.validity.expires > new Date('9999-12-31T23:59:59.999Z').getTime()) {
            throw new _1.ValidationError("A request to create a pass was generated. The request is rejected because the validity expiry date must be before 9999-12-31.");
        }
        if (!this.validity || this.validity.expires < this.validity.notBefore) {
            throw new _1.ValidationError("A request to create a pass was generated. The request is rejected because the validity expiry date must be after the not-before date.");
        }
    }
    Pass.build = function (_a) {
        var passWallet = _a.passWallet, account = _a.account, context = _a.context, vault = _a.vault, issuer = _a.issuer, subject = _a.subject, expires = _a.expires;
        return __awaiter(this, void 0, void 0, function () {
            var address, nonce, boxedSecret;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, vault.getWallet().deriveAddress({
                            path: subject.swap.serial,
                            type: modena_1.AddressType.BOX,
                        })];
                    case 1:
                        address = _b.sent();
                        return [4 /*yield*/, modena_1.Address.nonce()];
                    case 2:
                        nonce = _b.sent();
                        return [4 /*yield*/, address.boxEncrypt({
                                recipientPublicKey: new Uint8Array(Buffer.from(subject.swap.publicKey, 'base64')),
                                nonce: nonce,
                                message: new Uint8Array(Buffer.from(passWallet.mnemonic, 'utf-8')),
                            })];
                    case 3:
                        boxedSecret = _b.sent();
                        return [2 /*return*/, new Pass({
                                passWallet: passWallet.identity,
                                context: context.id,
                                account: account.id,
                                issuer: {
                                    id: issuer.id,
                                    publicKey: Buffer.from(address.publicKey).toString('base64'),
                                },
                                subject: {
                                    id: subject.id,
                                    publicKey: subject.swap.publicKey,
                                },
                                boxedSecret: Buffer.from(nonce).toString('base64') + "." + Buffer.from(boxedSecret).toString('base64'),
                                serial: subject.swap.serial,
                                validity: {
                                    notBefore: new Date().getTime(),
                                    expires: expires,
                                },
                            })];
                }
            });
        });
    };
    Pass.prototype.unboxWallet = function (vault) {
        return __awaiter(this, void 0, void 0, function () {
            var address, parts, nonce, unboxedSecret, mnemonic;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, vault.getWallet().deriveAddress({
                            path: this.serial,
                            type: modena_1.AddressType.BOX,
                        })];
                    case 1:
                        address = _a.sent();
                        parts = this.boxedSecret.split('.');
                        nonce = new Uint8Array(Buffer.from(parts[0], 'base64'));
                        return [4 /*yield*/, address.boxDecrypt({
                                senderPublicKey: new Uint8Array(Buffer.from(this.issuer.publicKey, 'base64')),
                                nonce: nonce,
                                box: new Uint8Array(Buffer.from(parts[1], 'base64')),
                            })];
                    case 2:
                        unboxedSecret = _a.sent();
                        mnemonic = Buffer.from(unboxedSecret).toString('utf-8');
                        return [2 /*return*/, modena_1.Wallet.create({
                                mnemonic: mnemonic,
                            })];
                }
            });
        });
    };
    return Pass;
}());
exports.Pass = Pass;
//# sourceMappingURL=pass.js.map